import fvObject from "../fvObject";
import Vue from 'vue';
export default class fvSubassembly extends fvObject {
    constructor(sContent,parent,system){
        super(sContent);
        this.isAnimation = false;
        this.originalSizes = {
            x : this.x,
            y : this.y,
            width : this.width,
            height : this.height,
            borderWidth:this.borderWidth
        }
        this.x += this.x * this.frameScaleX;
        this.y += this.y * this.frameScaleY;
        if(parent.type == "group"){
            this.x = this.x - parent.x;
            this.y = this.y - parent.y;
        }
        this.height += this.height * this.frameScaleY;
        this.width += this.width * this.frameScaleX;
        //标示未基本图元
        this.type = "basic";
        //父对象指针
        this.parent = parent;
        //注册名称
        this.name = this.registerName;
        //窗口大小
        this.windowSize = this.parent.windowSize;
        //图元原始（组态）大小
        this.originalSize = {
            x : this.x,
            y : this.y,
            width : this.width,
            height : this.height,
            borderWidth:this.borderWidth
        }
        //syste对象保存
        this.system = system;
        //计算缩放比例
        this.zoom();
        //初始化各种状态
        this.initState();
        //初始化各渲染信息
        this.initRender();
        //初始化动画
        this.initAnimation();
        //初始化各种状态
        this.definePropertyEx();
    }
    /*
        功能:初始化各种状态标记
        参数:无
        返回值:无
    */
    initState(){
         // 子类中使用
        this.isDelayedWaiting = false;
        //鼠标状态
        this.mouseState = 0;
        //选中状态
        this.selectState = 0;
        //有鼠标动作时,左键按下,右键按下状态
        this.lockState = 0;
        //是否禁止状态
        this.disableFlag = 0;
        //组件的显隐状态
        this.fcHide = this.fcHide || true;
        //禁用状态
        this.isEnable = this.isEnable || true;
        // 脚本控制组件显隐,权限高于动画
        this.fvScriptHide = this.fvScriptHide || true;
        //是否是放大状态
        this.isZoom = false;
        //是否是子对象
        this.isSub = false;
        //缓存是否需要更新
        this.isUpdataCache = true;
    }
    /*
        功能:初始化渲染模式
        参数:无
        返回值:无
    */
    initRender(){
        this.render = null;
        switch(this.renderType){
            case 1:
                this.render = new Vue.prototype.fvRenderMove(this.renderConfig);
                break;
            case 2:
                this.render = new Vue.prototype.fvRenderContract(this.renderConfig);
                break;
            case 3:
                this.render = new Vue.prototype.fvRenderGrid(this.renderConfig);
                break;
            case 4:
                this.render = new Vue.prototype.fvRenderLine(this.renderConfig);
                break;
            case 5:
                this.render = new Vue.prototype.fvRenderPath(this.renderConfig);
                break;
            case 6:
                this.isDelayedWaiting = true;
                this.render = new Vue.prototype.fvRenderTexture(this.renderConfig,this.system,this.delayedWaiting.bind(this));
                break;
            default:
                break;
        }
    }
    /*
        功能:初始创建动画执行对象
        参数:无
        返回值:无
    */
    initAnimation(){
        //周期执行动画对象
        this.preAnimation = {};
        //缓存绘制后动画对象
        this.posAnimation = {};
        //鼠标动画对象
        this.mouseAnimationList = {};
        //绘制前执行动画对象
        this.preAnimationList = {};
        for(var property in this.animation){
            //是否具有动画
            this.isAnimation = true;
            var ani = new Vue.prototype[property](this);
            switch(ani.type){
                case "fvContextMenu":
                case "fvMessage":
                case "fvVarInput":
                case "fvBoolInput":
                case "fvStringInput":
                case "fvVerticalDrag":
                case "fvHorDrag":
                case "fvLmousescript":
                case "fvRmousescript":
                case "fvMousescript":
                case "fvWindowOpen":
                    this.mouseAnimationList[ani.type] = ani;
                break;
                case "fvFlow":
                case "fvHorFill":
                case "fvRotateMove":
                case "fvVerticalFill":
                    this.preAnimationList[ani.type] = ani;
                    this.posAnimation[ani.type] = ani;
                break;
                case "fvHide":
                case "fvForbid":
                case "fvTwinkel":
                case "fvVerticalMove":
                case "fvHorMove":
                    this.preAnimation[ani.type] = ani;
                break;
                default:
                    this.preAnimationList[ani.type] = ani;
                break
            }
        }
    }
    /*
        功能:定义监听属性，用于脚本中对图元属性赋值的监听
        参数:无
        返回值:无
    */
    definePropertyEx(){
        Object.defineProperty(this,"X",{
            set : function(value){
                this.x = value;
                this.isUpdataCache = true;
            },
            get : function(){
                return this.x;
            }
        })
        Object.defineProperty(this,"Y",{
            set : function(value){
                this.y = value;
                this.isUpdataCache = true;
            },
            get : function(){
                return this.y;
            }
        })
        Object.defineProperty(this,"Width",{
            set : function(value){
                this.width = value;
                this.isUpdataCache = true;
            },
            get : function(){
                return this.width;
            }
        })
        Object.defineProperty(this,"Height",{
            set : function(value){
                this.height = value;
                this.isUpdataCache = true;
            },
            get : function(){
                return this.height;
            }
        })
        Object.defineProperty(this,"LColor",{
            set : function(value){
                if(value >= 0 && value < 2048){
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    this.borderColor = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    this.isUpdataCache = true;
                }else{
                    console.warn("颜色索引不存在");
                }
            },
            get : function(){
                return this.borderColor;
            }
        })
        Object.defineProperty(this,"FColor",{
            set : function(value){
                function zero_fill_hex(num, digits) {
                    var s = num.toString(16);
                    while (s.length < digits)
                      s = "0" + s;
                    return s;
                }
                function rgb2hex(rgb) {
                    if (rgb.charAt(0) == '#')
                        return rgb;
                    var ds = rgb.split(/\D+/);
                    var decimal = Number(ds[1]) * 65536 + Number(ds[2]) * 256 + Number(ds[3]);
                    return "#" + zero_fill_hex(decimal, 6);
                }
                if(value >= 0 && value < 2048){
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    this.color = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    if(this.renderType !== 0){
                        if(this.renderConfig.color){
                            this.renderConfig.color[0] = rgb2hex(this.color);
                        }
                    }
                    this.isUpdataCache = true;
                }else{
                    console.warn("颜色索引不存在");
                }
            },
            get : function(){
                return this.color;
            }
        })
    }
    /*
        功能:根据缩放比例缩放图元大小
        参数:无
        返回值:无
    */
    zoom(){
        this.magnification = this.parent.getMagnification();
        this.x = (this.originalSize.x * this.magnification.x);
        this.y = (this.originalSize.y * this.magnification.y);
        this.width = (this.originalSize.width * this.magnification.x);
        this.height = (this.originalSize.height * this.magnification.y);
        this.borderWidth = (this.originalSize.borderWidth * this.magnification.x);

    }
    /*
        功能:图元所有信息初始化完成后调用
        参数:无
        返回值:无
    */
    createSucss(){
        if(this.isSub){
            this.parent.updataSize({
                x : this.x,
                y : this.y,
                width : this.width,
                height : this.height,
                borderWidth : parseFloat(this.borderWidth),
                obj:this
            });
        }
    }
    /*
        功能:
        参数:无
        返回值:无
    */
    delayedWaiting(){
        if(typeof this.complete == "function"){
            this.complete(this);
        }
    }
    //获取当前的canvas
    setCanvas(canvas){
        this.canvas = canvas;
    }
    /*
        功能:图形绘制前执行
        参数:无
        返回值:无
    */
    executePreAnimation(canvas){
        this.canvas = canvas;
        // 打组禁止
        if(this.disableFlag){
            return;
        }
        // 当前图元禁止
        if(!this.fcHide){
            return;
        }
        for(var p in this.preAnimationList){
            this.preAnimationList[p].run(canvas,this.isEnable)
        }
    }
    /*
        功能:图形绘制后执行
        参数:无
        返回值:无
    */
    executePosAnimation(canvas){
        // 打组禁止
        if(this.disableFlag){
            return;
        }
        // 当前图元禁止
        if(!this.fcHide){
            return;
        }
        for(var p in this.posAnimation){
            if(typeof this.posAnimation[p].runEnd == "function"){
                this.posAnimation[p].runEnd(canvas);
            }
        }
    }
    /*
        功能:创建
        参数:无
        返回值:无
    */
    create(){
        this.init();
    }
    /*
        功能:缓存函数，需要被子类重写
        参数:无
        返回值:无
    */
    cache(canvas){
        return false;
    }
    /*
        功能:判断图元是否包含动画
        参数:type动图类型，或类型数组
        返回值:无
    */
    isHasAnimation(type){
        if(typeof type == "string"){
            if(this.mouseAnimationList[type])
                return true;
            else
                return false;
        }else if(typeof type == "object" && type.length >= 0){
            for(var p in this.mouseAnimationList){
                for(var i = 0; i < type.length;i++){
                    if(p == type[i]){
                        return true;
                    }
                }
            }
            return false
        }else{
            for(var p in this.animation){
               return true;
            }
            return false;
        }
    }
    /*
        功能:设置图元渲染模式
        参数:无
        返回值:无
    */
    Render(canvas){
        if(this.render){
            var rect = {
                left : this.cx,
                top : this.cy,
                bottom :parseFloat(this.cy + this.height),
                right : parseFloat(this.cx + this.width),
                width : parseFloat(this.width),
                height : parseFloat(this.height)
            }

            if(this.render.rend){
                if(canvas){
                    this.render.rend(canvas,rect,this);
                }
            }
        }
    }
    /*
        功能:更新缓存
        参数:无
        返回值:无
    */
    updataCache(){

    }
    /**
     * 
     */
    formatRect(){
        //设置画布x y 轴坐标减去宽高一半
        if(this.parent.type == "group"){
            this.cx = parseFloat(this.x + this.parent.x - (this.borderWidth)/2);
            this.cy = parseFloat(this.y + this.parent.y - (this.borderWidth)/2);
        }else{
            this.cx = parseFloat(this.x - (this.borderWidth)/2);
            this.cy = parseFloat(this.y - (this.borderWidth)/2);
        }
    }
    /*
        功能:初始化信息
        参数:无
        返回值:无
    */
    init() {
        this.formatRect();
    }
    /*
        功能:全屏（未发现调用，是否已经废弃？）
        参数:无
        返回值:无
    */
    fullScreenZoom(subScale){
        if(subScale && (this.isZoom == undefined || this.isZoom == false)){
            this.x = this.x * subScale.x;
            this.y = this.y * subScale.y;
            this.width = this.width * subScale.x;
            this.height = this.height * subScale.y;
            this.isZoom = true;
        }
    }
    /*
        功能:周期执行函数，由窗口根据数据刷新周期调用
        参数:无
        返回值:无
    */
    onTimer(){
        if(this.disableFlag){
            return;
        }
      
       
        // 当前图元禁止隐藏,脚本执行
        if(!this.fvScriptHide){
            for (const property in this.animation) {
                if(new Vue.prototype[property](this).type=="fvTwinkel"){
                    for(var p in this.preAnimation){
                        this.preAnimation[p].run(this.canvas,this.isEnable);
                    }
                }else{
                    return;
                }
            }
        }
        if(this.canvas){
            for(var p in this.preAnimation){
                this.preAnimation[p].run(this.canvas,this.isEnable);
            }
        }
        
    }
    /*
        功能:执行动画
        参数:无
        返回值:无
    */
    runAnimation(event, canvas, mouseAnimType){
        //要处理禁止动作//
        if(mouseAnimType == "fvForbid"){
            this.mouseAnimationList[fvForbid].run(event,canvas);
        }
        if(this.mouseAnimationList[mouseAnimType]){
            this.mouseAnimationList[mouseAnimType].run(event,canvas);
        }

    }

    /*
        功能:鼠标按下
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseDown(e,scaleObj,doFixEventOnMouseUp){
        this.mouseState = this.doFixedEvent(e,scaleObj,doFixEventOnMouseUp);
        if(this.mouseState){
            if(e.touches){
                this.runAnimation(e,this.parent.ctx,"fvLmousescript");
                this.runAnimation(e,this.parent.ctx,"fvVarInput");
                this.runAnimation(e,this.parent.ctx,"fvBoolInput");
                this.runAnimation(e,this.parent.ctx,"fvStringInput");
                this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                this.runAnimation(e,this.parent.ctx,"fvHorDrag");
                this.runAnimation(e,this.parent.ctx,"fvWindowOpen");
            }else{
                switch(e.button)
                {
                    case 0://鼠标左键按下
                    this.runAnimation(e,this.parent.ctx,"fvLmousescript");
                    this.runAnimation(e,this.parent.ctx,"fvVarInput");
                    this.runAnimation(e,this.parent.ctx,"fvBoolInput");
                    this.runAnimation(e,this.parent.ctx,"fvStringInput");
                    this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                    this.runAnimation(e,this.parent.ctx,"fvHorDrag");
                    this.runAnimation(e,this.parent.ctx,"fvWindowOpen");
                    //用于动画与点击同步执行
                    setTimeout(() => {
                        for(var p in this.preAnimationList){
                            //判断是否是 流动
                            if(p != "fvFlow"){
                                this.preAnimationList[p].run(this.parent.cacheCtx);
                            }
                        }
                    },300);
                    break;
                    case 1:
                        //this.runAnimation(e,this.parent.ctx,MOUSEANIMTYPE_RMOUSE);
                    break;
                    case 2:
                    this.runAnimation(e,this.parent.ctx,"fvRmousescript");
                    this.runAnimation(e,this.parent.ctx,"fvContextMenu");
                    break;
                    default:
                    break;
                }
            }
            
        }
        
    }

    /*
        功能:鼠标弹起
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseUp(e,scaleObj,doFixEventOnMouseUp){
        this.mouseState = this.doFixedEvent(e,scaleObj,doFixEventOnMouseUp);
        if(this.mouseState){
            if(e.touches){
                this.runAnimation(e,this.parent.ctx,"fvLmousescript",0);
                this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            }else{
                switch(e.button)
                {
                    case 0://鼠标左键抬起
                        this.runAnimation(e,this.parent.ctx,"fvLmousescript");
                        this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                        break;
                    case 1:
                        break;
                    case 2:
                        this.runAnimation(e,this.parent.ctx,"fvRmousescript");
                        break;
                    default:
                        break;
                }
            }
        }
        //鼠标在图元外抬起时
        this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
        this.runAnimation(e,this.parent.ctx,"fvHorDrag");
    }
    /*
        功能:鼠标移动
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseMove(e,scaleObj,doFixEventOnMouseUp){
        this.mouseState = this.doFixedEvent(e,scaleObj,doFixEventOnMouseUp);
        if(this.mouseState){
            this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            this.runAnimation(e,this.parent.ctx,"fvHorDrag");
        }
        this.runAnimation(e,this.parent.ctx,"fvMessage");
        this.runAnimation(e,this.parent.ctx,"fvMousescript");
    }
    /*
        功能:鼠标进入
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseEnter(e,scaleObj,doFixEventOnMouseUp){
        this.mouseState = this.doFixedEvent(e,scaleObj,doFixEventOnMouseUp);
        if(this.mouseState){
            this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            this.runAnimation(e,this.parent.ctx,"fvHorDrag");
            this.runAnimation(e,this.parent.ctx,"fvMessage");
            this.runAnimation(e,this.parent.ctx,"fvMousescript");
        }
    }
    /*
        功能:鼠标离开
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseLeave(e,){
        this.mouseState = false;
        this.runAnimation(e,this.parent.ctx,"fvMessage");
        this.runAnimation(e,this.parent.ctx,"fvMousescript");
    }

    /*
        功能:鼠标位置判断
        参数:event 属性信息 scaleObj 缩放信息
        返回值:是否命中图元
    */
    doFixedEvent(event, scaleObj, doFixEventOnMouseUp) {
        if (doFixEventOnMouseUp == undefined) {
            var doFixEventOnMouseUp = {
                top: 0,
                left: 0
            }
        }
        if (!this.isEnable) {
            //禁用时不响应事件
            return null;
        }
        if(this.canvas){
            //计算滚动条的位置。来实现滚后点击位置区域的判断准确性
            var eventX = event.clientX + this.canvas.canvas.parentNode.scrollLeft;
            if(scaleObj.turn == "portraits"){
                var eventY = event.clientY + this.canvas.canvas.parentNode.scrollTop +30;
            }else{
                var eventY = event.clientY + this.canvas.canvas.parentNode.scrollTop;
            }
            if(isApp()){
                var eventX = event.clientX + this.canvas.canvas.parentNode.parentNode.parentNode.parentNode.parentNode.scrollLeft;
                var eventY = event.clientY + this.canvas.canvas.parentNode.parentNode.parentNode.parentNode.parentNode.scrollTop;
            }
        }else{
            var eventX = this.mouseX(event);
            var eventY = this.mouseY(event);
            
        }
        //判断是否使用app打开pc窗口
        if (scaleObj.isApp == true && scaleObj.winType == "pc") {
            if (scaleObj.turn == "portrait") {
                var leftX = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                var rightX = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + leftX) - doFixEventOnMouseUp.left;
                var topY = parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top;
                var bottomY = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + topY) - doFixEventOnMouseUp.top;
                if (eventX < rightX &&
                    eventX > leftX &&
                    eventY < bottomY &&
                    eventY > topY) {
                    return true;
                } else {
                    return false;
                }
            } else if(scaleObj.turn == "portraits"){
                var leftX = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                var rightX = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + leftX) - doFixEventOnMouseUp.left;
                var topY = (parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top)+30;
                var bottomY = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + topY) - doFixEventOnMouseUp.top;
                
                if (eventX < rightX &&
                    eventX > leftX &&
                    eventY < bottomY &&
                    eventY > topY) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (scaleObj.embedView == 1) {

                    var leftX = this.cx + scaleObj.x;
                    var rightX = leftX + this.width;
                    var topY = this.cy + scaleObj.y + scaleObj.titleHeight;
                    var bottomY = this.height + topY;
                    if (eventX < rightX &&
                        eventX > leftX &&
                        eventY < bottomY &&
                        eventY > topY) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    var left = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                    var right = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + left) - doFixEventOnMouseUp.left;
                    var top = parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top;
                    var bottom = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + top) - doFixEventOnMouseUp.top;
                    //高度加30 是头部
                    if (eventY > left + 30 &&
                        eventY < right + 30 &&
                        eventX > window.innerWidth - bottom &&
                        eventX < window.innerWidth - top) {
                            
                        return true;
                    } else {
                        return false;
                    }
                }
            }

        } else if (scaleObj.winType != "pc") {
            //用于是否是app竖屏
            /**
             * 作用：用于app加载pc工程强制横屏 重新计算点击区域
             */
            var leftX = this.cx + scaleObj.x;
            var rightX = leftX + this.width;
            var topY = this.cy + scaleObj.y;
            var bottomY = this.height + topY;
            if (eventX < rightX &&
                eventX > leftX &&
                eventY < bottomY &&
                eventY > topY) {
                return true;
            } else {
                return false;
            }
        } else {
            // //因为垂直拖动动画this.cx,cy位置不对
            var y = parseInt(this.y - (this.borderWidth)/2);
            var x = parseInt(this.x - (this.borderWidth)/2);
            var leftX = x + scaleObj.x;
            var rightX = leftX + this.width;
            var topY = y + scaleObj.y + scaleObj.titleHeight;
            var bottomY = this.height + topY;
            if (eventX < rightX &&
                eventX > leftX &&
                eventY < bottomY &&
                eventY > topY) {
                return true;
            }else if(this.fctype=="fvLineObj"){
                return true;
            } else {
                return false;
            }
           
            // var leftX = this.cx + scaleObj.x;
            // var rightX = leftX + this.width;
            // var topY = this.cy + scaleObj.y + scaleObj.titleHeight;
            // var bottomY = this.height + topY;
            // console.log(eventX,"eventX");
            // console.log(eventY,"eventY");
            // console.log(rightX,"rightX");
            // console.log(leftX,"leftX");
            // console.log(topY,"topY");
            // console.log(bottomY,"bottomY");
            // if (eventX < rightX &&
            //     eventX > leftX &&
            //     eventY < bottomY) {
            //     return true;
            // } else {
            //     return false;
            // }
        }
    }
    /*
        功能:设置图元被选中
        参数:无
        返回值:无
    */
    select(flag){
        this.selectState = flag;
    }
    /*
        功能:允许或禁止
        参数:state 允许或禁止 标记, isGroup是否打组
        返回值:无
    */
    Enable(state, isGroup){
         //isEnable:false 禁止；true：不禁止
        this.isEnable = state ? true : false;
        if(isGroup){
            // 打组disableFlag true 禁止
            this.disableFlag = state ? false : true;
        }
    }
    /*
        功能:显示或隐藏
        参数:flag 允许或禁止 标记
        返回值:无
    */
    Show(flag, animation){
        //fcHide:false 隐藏；true：不隐藏
        this.isHide = flag ? true : false;
        // 动画控制
        this.fcHide = flag ? true : false;
        if(animation == "animation"){
            //脚本控制
            this.fvScriptHide = flag ? true : false;
        }
    }
    /*
        功能:获取线的格式
        参数:flag 允许或禁止 标记
        返回值:无
    */
    lineStyle(type){
        var size = "";
        switch (type){
            case 0 :
                size = [0,0];
                break;
            case 1 :
                size = [18,8];
                break;
            case 2 :
                size = [3.5,3.5];
                break;
            case 3 :
                size = [8,3.5,3.5];
                break;
            case 4 :
                size = [3,3,6];
                break;
            default :
                size = [0,0];
                break;
        }
        return size;
    }
    /*
        功能:鼠标坐标系转换
        参数:evt 鼠标信息
        返回值:无
    */
    mouseX(evt) {
        if (evt.pageX) return evt.pageX;
        else if (evt.clientX)
            return evt.clientX + (document.documentElement.scrollLeft ?
                    document.documentElement.scrollLeft :
                    document.body.scrollLeft);
        else return null;
    }
    /*
        功能:鼠标坐标系转换
        参数:evt 鼠标信息
        返回值:无
    */
    mouseY(evt) {
        if (evt.pageY) return evt.pageY;
        else if (evt.clientY)
            return evt.clientY + (document.documentElement.scrollTop ?
                    document.documentElement.scrollTop :
                    document.body.scrollTop);
        else return null;
    }
    /*
        功能:服务端实时数据返回通知接口
        参数:无
        返回值:无
    */
    onUpdata(){

    }
    /*
        功能:绘制
        参数:canvas 父对象的 canvas 对象
        返回值:无
    */

    onDraw(canvas,flag){

    }
    /*
        功能:重绘
        参数:scaleObj 缩放信息(此参数仅对精灵组件生效)
        返回值:无
    */
    reDraw(scaleObj){
        this.isUpdataCache = true;
        this.zoom();
        this.init();
        //缩放传参给fvText文本缩放信号，其他图元不需要处理
        //this.cache(this.parent.cacheCtx,"reDraw");
    }

    onClose(){
        
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/fvSubassembly.js